module.exports = __webpack_public_path__ + "img/points.ec75ad5d.svg";